/* eslint no-underscore-dangle: ["error", { "allow": ["_hsq"] }] */

export function identifyVisitor(email) {
    window._hsq = window._hsq || [];
    window._hsq.push(['identify', { email }]);
}

export function trackPageView(url) {
    window._hsq = window._hsq || [];

    window._hsq.push(['setPath', url]);
    window._hsq.push(['trackPageView']);
}

export function sendEvent(event, properties = {}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event,
        ...properties,
    });
}
